import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {faShareNodes} from '@fortawesome/pro-solid-svg-icons/faShareNodes'
import {DialogService} from '../../../craft/dialog/dialog.service'
import {ShareModalComponent} from '../share-modal/share-modal.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'

@Component({
  selector: 'bgo-share-button',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './share-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareButtonComponent {
  @Input() buttonText!: string
  @Input() modalTitle!: string
  @Input() modalPlot!: string

  protected readonly shareIcon = faShareNodes

  constructor(private readonly dialogService: DialogService) {}

  shareLink() {
    this.dialogService.show(ShareModalComponent, {
      title: this.modalTitle,
      plot: this.modalPlot,
      shareValue: window.location.href,
    })
  }
}
